import {FC} from 'react'
import {Input} from '../../../components/Input/Input'

interface AdditionalServicesTabProps {
  searchService: string
  setSearchService: (value: string) => void
  availableServices: any[]
  loadingServices: boolean
  selectedServices: any[]
  searchEntertainmentServices: () => void
  addServiceToExperience: (service: any) => void
  removeServiceFromExperience: (serviceId: number) => void
  updateServicePrice: (serviceId: number, price: number) => void
}

export const AdditionalServicesTab: FC<AdditionalServicesTabProps> = ({
  searchService,
  setSearchService,
  availableServices,
  loadingServices,
  selectedServices,
  searchEntertainmentServices,
  addServiceToExperience,
  removeServiceFromExperience,
  updateServicePrice,
}) => {
  return (
    <div className='row g-5'>
      {/* Card Esquerdo - Busca de Serviços */}
      <div className='col-lg-6'>
        <div className='card h-100 border border-secondary'>
          <div className='card-header border-0 py-5'>
            <h3 className='card-title align-items-start flex-column'>
              <span className='card-label fw-bolder fs-3 mb-1'>Serviços Disponíveis</span>
            </h3>
          </div>
          <div className='card-body pt-0'>
            {/* Área de Busca - Separada visualmente */}
            <div
              className='border border-secondary rounded p-4 mb-5'
              style={{backgroundColor: '#fafafaff'}}
            >
              <label className='form-label fw-bold fs-6 mb-3'>Buscar Serviços</label>
              <div className='d-flex gap-2'>
                <input
                  type='text'
                  className='form-control'
                  placeholder='Digite o nome do serviço...'
                  value={searchService}
                  onChange={(e) => setSearchService(e.target.value)}
                  onKeyPress={(e) => e.key === 'Enter' && searchEntertainmentServices()}
                />
                <button
                  type='button'
                  className='btn btn-primary'
                  onClick={searchEntertainmentServices}
                  disabled={loadingServices}
                  style={{minWidth: '45px'}}
                >
                  {loadingServices ? (
                    <span className='spinner-border spinner-border-sm'></span>
                  ) : (
                    <i className='fas fa-search'></i>
                  )}
                </button>
              </div>
            </div>

            {/* Área de Resultados - Separada visualmente */}
            <div className='separator separator-dashed my-5'></div>

            {loadingServices ? (
              <div className='text-center py-10'>
                <span className='spinner-border spinner-border-sm me-2'></span>
                <span className='text-muted'>Carregando serviços...</span>
              </div>
            ) : availableServices.length === 0 ? (
              <div className='text-center text-muted py-10'>
                <i className='fas fa-search fs-3x mb-3 opacity-25'></i>
                <p className='fs-6 fw-semibold'>Nenhum serviço encontrado</p>
                <p className='fs-7'>Use a busca acima para encontrar serviços</p>
              </div>
            ) : (
              <div>
                <label className='form-label fw-bold fs-6 mb-3'>
                  Resultados da Busca ({availableServices.length})
                </label>
                <div style={{maxHeight: '400px', overflowY: 'auto'}} className='pe-2'>
                  <div className='d-flex flex-column gap-2'>
                    {availableServices.map((service) => (
                      <div
                        key={service.id}
                        className='d-flex align-items-center justify-content-between p-3 border border-gray-300 rounded bg-hover-light-primary'
                        style={{transition: 'all 0.2s'}}
                      >
                        <span className='fw-semibold text-gray-800'>{service.title}</span>
                        <button
                          type='button'
                          className='btn btn-sm btn-icon btn-active-primary'
                          onClick={() => addServiceToExperience(service)}
                          title='Adicionar serviço'
                        >
                          <i className='fas fa-plus'></i>
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Card Direito - Serviços Selecionados */}
      <div className='col-lg-6'>
        <div className='card h-100 border border-secondary'>
          <div className='card-header border-0 py-5'>
            <h3 className='card-title align-items-start flex-column'>
              <span className='card-label fw-bolder fs-3 mb-1'>
                Serviços Selecionados
                {selectedServices.length > 0 && (
                  <span className='badge badge-light-primary ms-2'>{selectedServices.length}</span>
                )}
              </span>
            </h3>
          </div>
          <div className='card-body pt-0'>
            {selectedServices.length === 0 ? (
              <div className='text-center text-muted py-10'>
                <i className='fas fa-inbox fs-3x mb-4 opacity-25'></i>
                <p className='fs-6 fw-semibold'>Nenhum serviço selecionado</p>
                <p className='fs-7'>Adicione serviços usando o card ao lado</p>
              </div>
            ) : (
              <div>
                <div className='table-responsive' style={{maxHeight: '470px', overflowY: 'auto'}}>
                  <table className='table table-row-bordered table-row-gray-300 gy-4'>
                    <thead
                      style={{position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 10}}
                    >
                      <tr className='fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200'>
                        <th className='min-w-200px'>Serviço</th>
                        <th className='min-w-150px'>Valor (R$)</th>
                        <th className='text-end min-w-100px'>Ação</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedServices.map((service) => (
                        <tr key={service.id}>
                          <td>
                            <div className='d-flex flex-column'>
                              <span className='fw-bold text-gray-800'>{service.title}</span>
                            </div>
                          </td>
                          <td>
                            <div style={{width: '130px'}}>
                              <Input
                                inputAttr={{type: 'money'}}
                                value={service.customPrice || 0}
                                change={(val: number) => updateServicePrice(service.id, val || 0)}
                                currency={'BRL'}
                                locale={'pt-BR'}
                                marginTop={'0'}
                              />
                            </div>
                          </td>
                          <td className='text-end'>
                            <button
                              type='button'
                              className='btn btn-sm btn-icon btn-active-danger'
                              onClick={() => removeServiceFromExperience(service.id)}
                              title='Remover serviço'
                            >
                              <i className='fas fa-trash'></i>
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
